import styled from '@emotion/styled'
import { useState } from 'react'
import type { FC } from 'react'

import Image from '@segment/matcha/components/Image'
import Typography from '@segment/matcha/components/Typography'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import AccordionBase, * as Accordion from '@segment/matcha/recipes/Accordion'

import TopDestinationCategoriesPng from './assets/TopDestinationCategories.png'

const copy = {
  heading: `Top destination categories through the years`,
  description: `Before we get into the leading tools across the customer engagement stack, let’s first plot the trajectory of the different categories of tools on the Twilio Segment platform over the past five years.`,
  description2: `This graph not only illustrates a growth pattern – it narrates the evolving priorities of businesses in an increasingly data-centric world.`,
  description3: `Data warehouses, represented by the bold red line, have undergone an extraordinary surge, particularly notable from 2020 onwards. This trend can be attributed to several factors:`,
  list: [
    `Increasing challenges faced by data architects and platform leads, such as fragmented customer data and the need for efficient real-time data processing`,
    `The market demand for platforms that offer integration flexibility with existing systems and scalability to meet evolving business needs`,
    `Businesses outgrowing the limitations of traditional CRMs in favor of versatile, computation-ready data warehouses, spurred by the need for a single source of truth `,
  ],
}

const TopDestinationCategories: FC = () => {
  const [open, setOpen] = useState(false)

  return (
    <Wrapper>
      <StyledSection variant="centered">
        <Section.Contents>
          <AccordionBase>
            <Accordion.Header onClick={() => setOpen(!open)}>
              <Accordion.TitleWrapper>
                <Accordion.Title opened={open} variant="h2">
                  {copy.heading}
                </Accordion.Title>
              </Accordion.TitleWrapper>
              <Accordion.Icon opened={open} />
            </Accordion.Header>
            <Accordion.Body>
              {open && (
                <Accordion.ContentWrapper>
                  <Accordion.Text tag="div">
                    <Typography variant="pLarge">{copy.description}</Typography>
                  </Accordion.Text>
                  <StyledImage width="1302" height="1011" src={TopDestinationCategoriesPng} alt="" />
                  <Accordion.Text tag="div">
                    <Typography variant="pLarge">{copy.description2}</Typography>
                    <Typography variant="pLarge">{copy.description3}</Typography>
                    <List>
                      {copy.list.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </List>
                  </Accordion.Text>
                </Accordion.ContentWrapper>
              )}
            </Accordion.Body>
          </AccordionBase>
        </Section.Contents>
      </StyledSection>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  max-width: 1004px;
  margin: 0 auto;
`

const StyledSection = styled(SectionBase)`
  overflow: hidden;

  ${Section.Wrapper} {
    padding-bottom: 20px;
    gap: 40px;
  }
`

const StyledImage = styled(Image)`
  margin: 40px 0;
`

const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export default TopDestinationCategories
